'use strict';
require("./faqService");

angular.module('app.information.faq', [
  'app.information.faqService'
])
    .config([
        '$stateProvider',
        'PRODUCT',
        function ($stateProvider, product) {

            let logTemplate = 'components/information/faq/faqView.html';
            if (product.Code != 'htv') {
                logTemplate = 'assets/templates/' + product.Code + '/information/faqView.html';
            }

            $stateProvider.state('app.information.faq', {
                url: '/information/faq',
                templateUrl: logTemplate,
                controller: [
                    '$scope', 'app.information.faqService', function ($scope, faqService) {
                        return $scope.questions = faqService.questions
                    }
                ],
                title: 'FAQ'
            });
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/information/faq/faq.js